import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class SelectionFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'selection';
    this.parentButton = WBUtils.buttonSelect;
  }

  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    return null;
  }

  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
  }

  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
  }

}
